/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PAC API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BulkUpdateNotificationPreferencesDto,
  GetNotificationsResponseDto,
  ManagedUsersResponseDto,
  NotificationPreferencesDto,
  NotificationTypesDto,
  NotificationsControllerGetNotificationsParams,
  UpdateNotificationPreferenceDto
} from './pacApi.schemas';

import { axios } from '../../common/axios';
import type { ErrorType , BodyType } from '../../common/axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const notificationsControllerGetNotificationTypes = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<NotificationTypesDto>(
      {url: `/api/v1/notifications/types`, method: 'GET', signal
    },
      options);
    }




export const getNotificationsControllerGetNotificationTypesQueryKey = () => {
    return [
    `/api/v1/notifications/types`
    ] as const;
    }


export const getNotificationsControllerGetNotificationTypesQueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsControllerGetNotificationTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>> = ({ signal }) => notificationsControllerGetNotificationTypes(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsControllerGetNotificationTypesQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>>
export type NotificationsControllerGetNotificationTypesQueryError = ErrorType<unknown>


export function useNotificationsControllerGetNotificationTypes<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetNotificationTypes<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetNotificationTypes<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsControllerGetNotificationTypes<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerGetNotificationTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getNotificationsControllerGetNotificationTypesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsControllerGetNotificationTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>> = ({ signal }) => notificationsControllerGetNotificationTypes(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsControllerGetNotificationTypesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>>
export type NotificationsControllerGetNotificationTypesSuspenseQueryError = ErrorType<unknown>


export function useNotificationsControllerGetNotificationTypesSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetNotificationTypesSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetNotificationTypesSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsControllerGetNotificationTypesSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationTypes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerGetNotificationTypesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const notificationsControllerGetNotificationPreferences = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<NotificationPreferencesDto>(
      {url: `/api/v1/notifications/preferences`, method: 'GET', signal
    },
      options);
    }




export const getNotificationsControllerGetNotificationPreferencesQueryKey = () => {
    return [
    `/api/v1/notifications/preferences`
    ] as const;
    }


export const getNotificationsControllerGetNotificationPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsControllerGetNotificationPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>> = ({ signal }) => notificationsControllerGetNotificationPreferences(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsControllerGetNotificationPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>>
export type NotificationsControllerGetNotificationPreferencesQueryError = ErrorType<unknown>


export function useNotificationsControllerGetNotificationPreferences<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetNotificationPreferences<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetNotificationPreferences<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsControllerGetNotificationPreferences<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerGetNotificationPreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getNotificationsControllerGetNotificationPreferencesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsControllerGetNotificationPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>> = ({ signal }) => notificationsControllerGetNotificationPreferences(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsControllerGetNotificationPreferencesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>>
export type NotificationsControllerGetNotificationPreferencesSuspenseQueryError = ErrorType<unknown>


export function useNotificationsControllerGetNotificationPreferencesSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetNotificationPreferencesSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetNotificationPreferencesSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsControllerGetNotificationPreferencesSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerGetNotificationPreferencesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const notificationsControllerUpdateNotificationPreference = (
    updateNotificationPreferenceDto: BodyType<UpdateNotificationPreferenceDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<void>(
      {url: `/api/v1/notifications/preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateNotificationPreferenceDto, signal
    },
      options);
    }



export const getNotificationsControllerUpdateNotificationPreferenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerUpdateNotificationPreference>>, TError,{data: BodyType<UpdateNotificationPreferenceDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerUpdateNotificationPreference>>, TError,{data: BodyType<UpdateNotificationPreferenceDto>}, TContext> => {

const mutationKey = ['notificationsControllerUpdateNotificationPreference'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsControllerUpdateNotificationPreference>>, {data: BodyType<UpdateNotificationPreferenceDto>}> = (props) => {
          const {data} = props ?? {};

          return  notificationsControllerUpdateNotificationPreference(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationsControllerUpdateNotificationPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerUpdateNotificationPreference>>>
    export type NotificationsControllerUpdateNotificationPreferenceMutationBody = BodyType<UpdateNotificationPreferenceDto>
    export type NotificationsControllerUpdateNotificationPreferenceMutationError = ErrorType<unknown>

    export const useNotificationsControllerUpdateNotificationPreference = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerUpdateNotificationPreference>>, TError,{data: BodyType<UpdateNotificationPreferenceDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsControllerUpdateNotificationPreference>>,
        TError,
        {data: BodyType<UpdateNotificationPreferenceDto>},
        TContext
      > => {
      return useMutation(getNotificationsControllerUpdateNotificationPreferenceMutationOptions(options), queryClient);
    }
    export const notificationsControllerGetManagedUsers = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<ManagedUsersResponseDto>(
      {url: `/api/v1/notifications/managed-users`, method: 'GET', signal
    },
      options);
    }




export const getNotificationsControllerGetManagedUsersQueryKey = () => {
    return [
    `/api/v1/notifications/managed-users`
    ] as const;
    }


export const getNotificationsControllerGetManagedUsersQueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsControllerGetManagedUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>> = ({ signal }) => notificationsControllerGetManagedUsers(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsControllerGetManagedUsersQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>>
export type NotificationsControllerGetManagedUsersQueryError = ErrorType<unknown>


export function useNotificationsControllerGetManagedUsers<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetManagedUsers<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetManagedUsers<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsControllerGetManagedUsers<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerGetManagedUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getNotificationsControllerGetManagedUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsControllerGetManagedUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>> = ({ signal }) => notificationsControllerGetManagedUsers(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsControllerGetManagedUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>>
export type NotificationsControllerGetManagedUsersSuspenseQueryError = ErrorType<unknown>


export function useNotificationsControllerGetManagedUsersSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetManagedUsersSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetManagedUsersSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsControllerGetManagedUsersSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUsers>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerGetManagedUsersSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const notificationsControllerGetManagedUserNotificationPreferences = (
    userId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<NotificationPreferencesDto>(
      {url: `/api/v1/notifications/users/${userId}/preferences`, method: 'GET', signal
    },
      options);
    }




export const getNotificationsControllerGetManagedUserNotificationPreferencesQueryKey = (userId: string,) => {
    return [
    `/api/v1/notifications/users/${userId}/preferences`
    ] as const;
    }


export const getNotificationsControllerGetManagedUserNotificationPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError = ErrorType<unknown>>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsControllerGetManagedUserNotificationPreferencesQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>> = ({ signal }) => notificationsControllerGetManagedUserNotificationPreferences(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsControllerGetManagedUserNotificationPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>>
export type NotificationsControllerGetManagedUserNotificationPreferencesQueryError = ErrorType<unknown>


export function useNotificationsControllerGetManagedUserNotificationPreferences<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError = ErrorType<unknown>>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetManagedUserNotificationPreferences<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetManagedUserNotificationPreferences<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsControllerGetManagedUserNotificationPreferences<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerGetManagedUserNotificationPreferencesQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getNotificationsControllerGetManagedUserNotificationPreferencesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError = ErrorType<unknown>>(userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsControllerGetManagedUserNotificationPreferencesQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>> = ({ signal }) => notificationsControllerGetManagedUserNotificationPreferences(userId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsControllerGetManagedUserNotificationPreferencesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>>
export type NotificationsControllerGetManagedUserNotificationPreferencesSuspenseQueryError = ErrorType<unknown>


export function useNotificationsControllerGetManagedUserNotificationPreferencesSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError = ErrorType<unknown>>(
 userId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetManagedUserNotificationPreferencesSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetManagedUserNotificationPreferencesSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsControllerGetManagedUserNotificationPreferencesSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetManagedUserNotificationPreferences>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerGetManagedUserNotificationPreferencesSuspenseQueryOptions(userId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const notificationsControllerUpdateManagedUserNotificationPreference = (
    userId: string,
    updateNotificationPreferenceDto: BodyType<UpdateNotificationPreferenceDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<void>(
      {url: `/api/v1/notifications/users/${userId}/preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateNotificationPreferenceDto, signal
    },
      options);
    }



export const getNotificationsControllerUpdateManagedUserNotificationPreferenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerUpdateManagedUserNotificationPreference>>, TError,{userId: string;data: BodyType<UpdateNotificationPreferenceDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerUpdateManagedUserNotificationPreference>>, TError,{userId: string;data: BodyType<UpdateNotificationPreferenceDto>}, TContext> => {

const mutationKey = ['notificationsControllerUpdateManagedUserNotificationPreference'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsControllerUpdateManagedUserNotificationPreference>>, {userId: string;data: BodyType<UpdateNotificationPreferenceDto>}> = (props) => {
          const {userId,data} = props ?? {};

          return  notificationsControllerUpdateManagedUserNotificationPreference(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationsControllerUpdateManagedUserNotificationPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerUpdateManagedUserNotificationPreference>>>
    export type NotificationsControllerUpdateManagedUserNotificationPreferenceMutationBody = BodyType<UpdateNotificationPreferenceDto>
    export type NotificationsControllerUpdateManagedUserNotificationPreferenceMutationError = ErrorType<unknown>

    export const useNotificationsControllerUpdateManagedUserNotificationPreference = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerUpdateManagedUserNotificationPreference>>, TError,{userId: string;data: BodyType<UpdateNotificationPreferenceDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsControllerUpdateManagedUserNotificationPreference>>,
        TError,
        {userId: string;data: BodyType<UpdateNotificationPreferenceDto>},
        TContext
      > => {
      return useMutation(getNotificationsControllerUpdateManagedUserNotificationPreferenceMutationOptions(options), queryClient);
    }
    export const notificationsControllerBulkUpdateManagedUserNotificationPreferences = (
    bulkUpdateNotificationPreferencesDto: BodyType<BulkUpdateNotificationPreferencesDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<void>(
      {url: `/api/v1/notifications/users/preferences/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkUpdateNotificationPreferencesDto, signal
    },
      options);
    }



export const getNotificationsControllerBulkUpdateManagedUserNotificationPreferencesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerBulkUpdateManagedUserNotificationPreferences>>, TError,{data: BodyType<BulkUpdateNotificationPreferencesDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerBulkUpdateManagedUserNotificationPreferences>>, TError,{data: BodyType<BulkUpdateNotificationPreferencesDto>}, TContext> => {

const mutationKey = ['notificationsControllerBulkUpdateManagedUserNotificationPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsControllerBulkUpdateManagedUserNotificationPreferences>>, {data: BodyType<BulkUpdateNotificationPreferencesDto>}> = (props) => {
          const {data} = props ?? {};

          return  notificationsControllerBulkUpdateManagedUserNotificationPreferences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationsControllerBulkUpdateManagedUserNotificationPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerBulkUpdateManagedUserNotificationPreferences>>>
    export type NotificationsControllerBulkUpdateManagedUserNotificationPreferencesMutationBody = BodyType<BulkUpdateNotificationPreferencesDto>
    export type NotificationsControllerBulkUpdateManagedUserNotificationPreferencesMutationError = ErrorType<unknown>

    export const useNotificationsControllerBulkUpdateManagedUserNotificationPreferences = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerBulkUpdateManagedUserNotificationPreferences>>, TError,{data: BodyType<BulkUpdateNotificationPreferencesDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsControllerBulkUpdateManagedUserNotificationPreferences>>,
        TError,
        {data: BodyType<BulkUpdateNotificationPreferencesDto>},
        TContext
      > => {
      return useMutation(getNotificationsControllerBulkUpdateManagedUserNotificationPreferencesMutationOptions(options), queryClient);
    }
    export const notificationsControllerGetNotifications = (
    params?: NotificationsControllerGetNotificationsParams,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetNotificationsResponseDto>(
      {url: `/api/v1/notifications`, method: 'GET',
        params, signal
    },
      options);
    }




export const getNotificationsControllerGetNotificationsQueryKey = (params?: NotificationsControllerGetNotificationsParams,) => {
    return [
    `/api/v1/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getNotificationsControllerGetNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError = ErrorType<unknown>>(params?: NotificationsControllerGetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsControllerGetNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>> = ({ signal }) => notificationsControllerGetNotifications(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsControllerGetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>>
export type NotificationsControllerGetNotificationsQueryError = ErrorType<unknown>


export function useNotificationsControllerGetNotifications<TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError = ErrorType<unknown>>(
 params: undefined |  NotificationsControllerGetNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetNotifications<TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError = ErrorType<unknown>>(
 params?: NotificationsControllerGetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetNotifications<TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError = ErrorType<unknown>>(
 params?: NotificationsControllerGetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsControllerGetNotifications<TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError = ErrorType<unknown>>(
 params?: NotificationsControllerGetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerGetNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getNotificationsControllerGetNotificationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError = ErrorType<unknown>>(params?: NotificationsControllerGetNotificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsControllerGetNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>> = ({ signal }) => notificationsControllerGetNotifications(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsControllerGetNotificationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>>
export type NotificationsControllerGetNotificationsSuspenseQueryError = ErrorType<unknown>


export function useNotificationsControllerGetNotificationsSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError = ErrorType<unknown>>(
 params: undefined |  NotificationsControllerGetNotificationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetNotificationsSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError = ErrorType<unknown>>(
 params?: NotificationsControllerGetNotificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsControllerGetNotificationsSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError = ErrorType<unknown>>(
 params?: NotificationsControllerGetNotificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsControllerGetNotificationsSuspense<TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError = ErrorType<unknown>>(
 params?: NotificationsControllerGetNotificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationsControllerGetNotifications>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerGetNotificationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const notificationsControllerMarkAllNotificationsAsRead = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<void>(
      {url: `/api/v1/notifications/read-all`, method: 'POST', signal
    },
      options);
    }



export const getNotificationsControllerMarkAllNotificationsAsReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerMarkAllNotificationsAsRead>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerMarkAllNotificationsAsRead>>, TError,void, TContext> => {

const mutationKey = ['notificationsControllerMarkAllNotificationsAsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsControllerMarkAllNotificationsAsRead>>, void> = () => {


          return  notificationsControllerMarkAllNotificationsAsRead(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationsControllerMarkAllNotificationsAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerMarkAllNotificationsAsRead>>>

    export type NotificationsControllerMarkAllNotificationsAsReadMutationError = ErrorType<unknown>

    export const useNotificationsControllerMarkAllNotificationsAsRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerMarkAllNotificationsAsRead>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsControllerMarkAllNotificationsAsRead>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getNotificationsControllerMarkAllNotificationsAsReadMutationOptions(options), queryClient);
    }
    export const notificationsControllerMarkNotificationAsRead = (
    notificationId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<void>(
      {url: `/api/v1/notifications/${notificationId}`, method: 'POST', signal
    },
      options);
    }



export const getNotificationsControllerMarkNotificationAsReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerMarkNotificationAsRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerMarkNotificationAsRead>>, TError,{notificationId: string}, TContext> => {

const mutationKey = ['notificationsControllerMarkNotificationAsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsControllerMarkNotificationAsRead>>, {notificationId: string}> = (props) => {
          const {notificationId} = props ?? {};

          return  notificationsControllerMarkNotificationAsRead(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationsControllerMarkNotificationAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerMarkNotificationAsRead>>>

    export type NotificationsControllerMarkNotificationAsReadMutationError = ErrorType<unknown>

    export const useNotificationsControllerMarkNotificationAsRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerMarkNotificationAsRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsControllerMarkNotificationAsRead>>,
        TError,
        {notificationId: string},
        TContext
      > => {
      return useMutation(getNotificationsControllerMarkNotificationAsReadMutationOptions(options), queryClient);
    }
